'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var plugin = require('tailwindcss/plugin');
var colors = require('../base/colors.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var plugin__default = /*#__PURE__*/_interopDefaultCompat(plugin);

var focusRing = plugin__default.default(({ addUtilities, theme })=>{
    const outlineStyles = {
        outlineWidth: theme('outlineWidth.2'),
        outlineStyle: 'solid'
    };
    const defaultStyles = {
        outlineColor: theme('outlineColor.blue.300')
    };
    const errorStyles = {
        outlineColor: `light-dark(${colors.colors.red['500']}, ${colors.colors.red['300']})`
    };
    /**
     * EDS focus ring styling helper classes.
     *
     * Used in elements where focus state requires ring. Due to simplicity in
     * styling and need for offset, `outline` is preferred CSS attribute.
     *
     */ const focusRings = {
        '.focus-ring': {
            ...outlineStyles,
            ...defaultStyles,
            outlineOffset: theme('outlineOffset.2')
        },
        '.focus-ring-inset': {
            ...outlineStyles,
            ...defaultStyles,
            outlineOffset: '-2px'
        },
        '.focus-ring-error': {
            ...outlineStyles,
            ...errorStyles,
            outlineOffset: theme('outlineOffset.2')
        },
        '.focus-ring-error-inset': {
            ...outlineStyles,
            ...errorStyles,
            outlineOffset: '-2px'
        }
    };
    addUtilities(focusRings);
});

exports.default = focusRing;
//# sourceMappingURL=focusRing.js.map
